import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class UpdateMarkberedningsMetodCommand extends BasicCommand<UpdateMarkberedningsMetodCommand> {
    readonly atgardGuid: string;
    readonly metod: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateMarkberedningsMetodCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "AnmalanTradslag";

    get primaryKey(): IPrimaryKey<UpdateMarkberedningsMetodCommand> {
        return {
            guid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, metod: string) {
        super(UpdateMarkberedningsMetodCommand.$type, UpdateMarkberedningsMetodCommand.$groupKey, CommandType.Replace);
        this.atgardGuid = atgardGuid;
        this.metod = metod;
    }
}
